import Head from 'next/head'
import Script from 'next/script'
import React from 'react'
import { getPublicLayout } from '@public/components/PublicLayout'
import { Flex } from 'components/Layout'
import { environment } from 'constants/environment'
import { SPACE } from 'Theme'
import { prepareGetStaticNavigationProps } from '../utils/prepareGetStaticNavigationProps'

export const HolidaySweep = () => (
  <>
    <Head>
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="" />
      <meta
        name="twitter:description"
        content="Enter your information for a chance to win."
      />
      <meta name="twitter:image" content="" />
      <meta
        property="og:url"
        content={`${environment.APP_URL}/holiday-sweeps`}
      />
      <meta property="og:type" content="article" />
      <meta property="og:title" content="" />

      <meta property="og:site_name" content="" />
      <meta property="fb:admins" content="1088490351" />
      <meta property="fb:admins" content="11512735" />
      <meta property="fb:admins" content="1088490312" />
      <meta
        property="og:description"
        content="Enter your information for a chance to win."
      />
    </Head>
    <Flex width="100%" height="100%" justifyContent="center" mb={SPACE.PX_15}>
      <div id="vsscript_98238_496399" />
      <Script
        async
        src="https://app.viralsweep.com/vsa-widget-af1471-98238.js?sid=98238_496399"
      />
    </Flex>
  </>
)

export function getStaticProps() {
  return prepareGetStaticNavigationProps()
}

HolidaySweep.getLayout = getPublicLayout
